module.exports = {
          srcSet: __webpack_public_path__ + "3be21f40b6dad25baf2c54901093acf6-1148.png"+" 1148w",
          images:[ {path: __webpack_public_path__ + "3be21f40b6dad25baf2c54901093acf6-1148.png",width: 1148,height: 870}],
          src: __webpack_public_path__ + "3be21f40b6dad25baf2c54901093acf6-1148.png",
          toString:function(){return __webpack_public_path__ + "3be21f40b6dad25baf2c54901093acf6-1148.png"},
          
          width: 1148,
          height: 870
        }